import { Autocomplete, Backdrop, Box, Checkbox, CircularProgress, FormHelperText, ListItemText, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as constants from "../../../constants";
import { RootState } from "../../../store/store";
import basestyle from "../../CSS/Base.module.css";
import { default as CancelPopUp, default as MappingDetailsWarningPopUp } from "../../PopUp/PopUp";
import { getBudgetForecastEligibleYearByParticipantId, getForecastMappingDetailsByFinancialYearAndParticipantId, getForecastMappingDetailsByFinancialYearsAndParticipantId, getParticipantFileMappingByParticipantIdType } from "../services/Financials/budget.service";
import { SectionTitle, StyledInputLabel, StyledOneChildContainer, StyledParentContainer, StyledTwoChildContainer, SubSectionTitle } from "../StyledComponents/Container";

import { AxiosError } from "axios";
import React from "react";
import * as XLSX from "xlsx";
import CustomAutocomplete from "../../../shared/AutoComplete";
import ContainedButton from "../../../shared/Button/CustomContainedButton";
import OutlinedButton from "../../../shared/Button/customOutlinedButton";
import CustomPopper from "../../../shared/CustomPopper";
import CustomTextField from "../../../shared/CustomTextFeild";
import { StyledTable } from "../../../shared/ReusableTable/TableStyle";
import { resetImportDataDetails, setImportDataDetails } from "../../../store/Financials/importDataSlice";
import { postParticipantFileMapping } from "../services/Financials/actuals.service";
import { ParticipantsFileColumnMappingsVO } from "../services/Financials/financials";
import CommonUtilities from "../Utils/CommonUtilities";
import FileUpload from "../Utils/FileUpload";
import { formatCurrency, formatCurrencywithoutDoller } from "../Utils/formatUtils";
import { notifyUser } from "../Utils/notifyUser";

interface FileInfo {
    name: string;
    size: number;
    type: string;
    file: File;
}

interface PeriodOption {
    id: number;
    value: string;
    name: string;
}

const defaultSelectOption = {
    forecastSubChartId: null,
    displayName: constants.SELECT_PLACEHOLDER,
    type: '',
    subChartAccountNumber: ''
};

const BudgetImport = () => {
    const dispatch = useDispatch();
    const { state } = useLocation();
    const navigate = useNavigate();
    const importData = useSelector((state: RootState) => state.importData);
    const [openPopUp, setOpenPopUp] = useState(false);
    const [openMappingDetailsPopUp, setOpenMappingDetailsPopUp] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingFlag, setLoadingFlag] = useState(false);
    const [fileChanged, setFileChanged] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const [mappingDetailsFlag, setMappingDetailsFlag] = useState(false);
    const [budgetLockedMessageFlag, setBudgetLockedMessageFlag] = useState(false);
    const [fileColumnMappingId, setFileColumnMappingId] = useState(importData?.fileColumnMappingDetailes?.id ?? 0);
    const [yearError, setYearError] = useState(false);
    const [budgetYearsList, SetBudgetYearsList] = useState<string[]>([]);
    const [month, setMonth] = useState<PeriodOption | null>(importData?.month ?? null);
    const [year, setYear] = useState<string>(importData?.year ?? "");
    const [period, setPeriod] = useState<PeriodOption | null>(importData?.period ?? null);
    const [quarter, setQuarter] = useState<PeriodOption | null>(importData?.quarter ?? null);
    const [semiannually, setSemiannually] = useState<PeriodOption | null>(importData?.semiannually ?? null);
    const [yearlyType, setYearlyType] = useState<PeriodOption | null>(importData?.yearlyType ?? null);
    const [selectSheet, setSelectSheet] = useState<string>(importData?.selectSheet ?? "");
    const [amountColumn, setAmountColumn] = useState<string>(importData?.amountColumn ?? "");
    const [descriptionColumn, setDescriptionColumn] = useState<{ id: number; name: string }[]>(importData?.descriptionColumn ?? []);
    const [sheets, setSheets] = useState<string[]>(importData?.sheets ?? []);
    const [descriptionColumnList, setDescriptionColumnList] = useState<{ id: number; name: string }[]>(importData?.descriptionColumnList ?? []);
    const [amountColumnList, setAmountColumnList] = useState<string[]>(importData?.amountColumnList ?? []);
    const [rowData, setRowData] = useState<any[]>(importData?.rowData ?? []);
    const [standardChartList, setStandardChartList] = useState([]);
    const [participantId, setParticipantId] = useState(0);
    const [monthCount, setMonthCount] = useState(0);
    const listingPageType = importData?.listingPageType ?? "";
    const [file, setFile] = useState<any>(null);
    const [selectedFile, setSelectedFile] = useState(importData?.selectedFile ?? "");
    const userDetails = useSelector((state: RootState) => state.auth);
    const [amountColumnError, setAmountColumnError] = useState("");
    const [fileErrorMessage, setFileErrorMessage] = useState("");
    const [forecastMappingDetails, setForecastMappingDetails] = useState<string[]>(importData?.forecastMappingDetails ?? []);
    const [transformedImport, setTransformedImport] = useState<any[]>(importData?.transformedImport ?? []);
    const monthOrder = CommonUtilities.monthOrderList;
    const monthOrderOptions = CommonUtilities.monthsOrderListOptions;
    const semiannuallys = CommonUtilities.semiannuallyOptions;
    const quarters = CommonUtilities.quarterOptions;
    const [version, setVersion] = useState<number | null>(null);
    const [amounts, setAmounts] = useState<Record<string, string>>({});
    const { t } = useTranslation();
    const translate = t as (key: string) => string;
    const columnName = CommonUtilities.columnName;
    const [columns, setColumns] = useState<any[]>([]);
    const SELECT_ALL_OPTION = { id: '0', name: 'Select All' };
    const mergedOptions = [SELECT_ALL_OPTION, ...descriptionColumnList];
    const getFiscalYearMonths = (fy: string) => {
        if (!fy.startsWith("FY")) return [];

        const endYear = 2000 + parseInt(fy.slice(2));
        const startYear = endYear - 1;

        return [
            { name: "Jul", year: startYear },
            { name: "Aug", year: startYear },
            { name: "Sep", year: startYear },
            { name: "Oct", year: startYear },
            { name: "Nov", year: startYear },
            { name: "Dec", year: startYear },
            { name: "Jan", year: endYear },
            { name: "Feb", year: endYear },
            { name: "Mar", year: endYear },
            { name: "Apr", year: endYear },
            { name: "May", year: endYear },
            { name: "Jun", year: endYear },
        ].map((month) => ({
            id: month.name,
            label: `${month.name} ${month.year}`,
            minWidth: 120,
        }));
    };
    const handleDioceseGLMappingChange = (index: number, newValue: any) => {
        const updatedData = [...transformedImport];
        updatedData[index] = {
            ...updatedData[index],
            dioceseGLMapping:
                newValue?.forecastSubChartId === null ? null : newValue,
        };
        setTransformedImport(updatedData);
    };

    const handleForecastChange = (fieldId: string, value: string, rowIndex: number) => {
        const updatedTransformed = [...transformedImport];
        const currentRow = { ...updatedTransformed[rowIndex], [fieldId]: value };
        const monthKeys = CommonUtilities.monthRegularList;
        let total = 0;
        for (const month of monthKeys) {
            const raw = month === fieldId ? value : currentRow[month] ?? "0";
            const numeric = parseFloat(raw.toString().replace(/[^0-9.-]+/g, "")) || 0;
            total += numeric;
        }

        currentRow.amount = formatCurrency(total);
        updatedTransformed[rowIndex] = currentRow;

        setTransformedImport(updatedTransformed);
    };

    const handleForecastBlur = (month: string, value: any, rowIndex: number) => {
    };

    useEffect(() => {
        let filteredMonths = [...monthOrder];

        const newColumns = [
            { id: "locationGL", label: translate('locationGL'), minWidth: 100, align: "left" },
            { id: "amount", label: translate('amount'), minWidth: 120, align: "right" },
            ...filteredMonths.map((monthObj) => {
                const fiscalYearMonths = getFiscalYearMonths(year);
                const matchedMonth = fiscalYearMonths.find(m => m.id === monthObj);
                return {
                    id: monthObj,
                    label: matchedMonth ? ` ${matchedMonth.label}` : monthObj,
                    minWidth: 120,
                };
            }),
            { id: "dioceseGLMapping", label: translate('dioceseGLMapping'), minWidth: 220, align: "center" },
        ];

        setColumns(newColumns);
        setMonthCount(filteredMonths.length);
    }, [period, quarter, semiannually, yearlyType, month, year]);



    const onchangeAmount = (newValue: any) => {
        setAmountColumnError("");
        if (!newValue || !amountColumnList.includes(newValue)) {
            setAmountColumnError(translate('pleaseSelectAValidAmountColumn'));
            return;
        }
        setAmountColumn(newValue);
    };
    const handleAmountChange = (monthId: number, newValue: string) => {
        setAmounts((prevAmounts) => ({
            ...prevAmounts,
            [monthId]: newValue,
        }));
    };

    async function saveParticipantFileMapping(): Promise<number | null> {
        const descriptionColumnsString = descriptionColumn.map((item: { name: string }) => item.name).join(",");

        const participantsFileColumnMappingsVO: ParticipantsFileColumnMappingsVO = {
            id: importData?.fileColumnMappingDetailes ? importData.fileColumnMappingDetailes?.id : 0,
            participantId: participantId,
            fileType: constants.TYPE_BUDGET,
            formatType: "",
            descriptionColumns: descriptionColumnsString,
            amountColumn: amountColumn,
            isActive: constants.IS_ACTIVE_YES,
            version: importData?.fileColumnMappingDetailes ? importData.fileColumnMappingDetailes.version : 0,
            clientId: userDetails.clientId
        };

        try {
            const responseList = await postParticipantFileMapping(participantsFileColumnMappingsVO);

            if (responseList?.status === constants.STATUS_CODES.SUCCESS) {
                const fileColumnMappingDetailes = responseList.data?.data?.participantsFileColumnMappingsVOList[0];
                setFileColumnMappingId(fileColumnMappingDetailes?.id ?? 0);
                dispatch(
                    setImportDataDetails({
                        ...importData,
                        fileColumnMappingDetailes: fileColumnMappingDetailes,
                    })
                );

                return fileColumnMappingDetailes || null;
            } else {
                notifyUser(responseList?.data?.message, 'error', translate('budgetImport'));
                return null;
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
            notifyUser(constants.ERROR_VALIDATION_MESSAGE_ERROR_OCCURRED_WHILE_POSTING_THE_EXCEL_SHEET_DETAILES, 'error', translate('budgetImport'));
            return null;
        } finally {
            setLoadingFlag(false);
            setMappingDetailsFlag(false);
        }
    }
    const handleContinue = async () => {
        const checkDuplicateDisplayNames = (data: any) => {
            const displayNames = new Map();
            let duplicateFound = false;
            data.forEach((item: any) => {
                if (item.dioceseGLMapping) {
                    const displayName = item.dioceseGLMapping.displayName;
                    if (displayNames.has(displayName)) {
                        displayNames.set(displayName, displayNames.get(displayName) + 1);
                    } else {
                        displayNames.set(displayName, 1);
                    }
                }
            });
            displayNames.forEach((count, displayName) => {
                if (count > 1) {
                    duplicateFound = true;
                    setOpenMappingDetailsPopUp(true);
                }
            });
            return duplicateFound;
        };

        const hasDuplicates = checkDuplicateDisplayNames(transformedImport);
        if (!hasDuplicates) {
            handleMappingDetailsConfirm();
        }
    };

    const handleMappingDetailsConfirm = async () => {
        setOpenMappingDetailsPopUp(false);
        let latestDetailes = importData?.fileColumnMappingDetailes;
        if (mappingDetailsFlag) {
            const fileMappingDetails = await saveParticipantFileMapping();
            latestDetailes = fileMappingDetails || importData?.fileColumnMappingDetailes;
        }

        dispatch(setImportDataDetails({
            listingPageType: "budgetListing",
            rowData,
            quarter,
            period,
            semiannually,
            month,
            yearlyType,
            year,
            selectSheet,
            selectedFile,
            sheets,
            descriptionColumnList,
            amountColumnList,
            amountColumn,
            descriptionColumn,
            isInitialRender: false,
            transformedImport,
            forecastMappingDetails,
            fileColumnMappingDetailes: latestDetailes,
        }));
        navigate("/budgetImported", { state: { version: version } });
    };

    useEffect(() => {
        setParticipantId(userDetails?.defaultParticipantId);
    }, [userDetails]);

    const validateAmountNotInDescription = (descCols: any, amtCol: any) => {
        if (!amtCol || !descCols?.length) {
            setAmountColumnError("");
            return;
        }
        const match = descCols.some((desc: any) => desc.name === amtCol);
        if (match) {
            setAmountColumnError(translate('amountColumnShouldNotBeOneOfTheDescriptionColumns'));
        } else {
            setAmountColumnError("");
        }

        setMappingDetailsFlag(true);
    };

    const validateBeforeUpload = () => {
        let shouldDisable = false;
        let errors = {
            yearError: false,
        };

        if (!year) {
            shouldDisable = true;
            errors.yearError = true;
        }

        setYearError(errors.yearError);

        setIsDisabled(shouldDisable);
        return !shouldDisable;
    };

    const handleFilesSelected = (files: File[]) => {
        if (!files || files.length === 0) return;

        const file = files[0];
        const fileName = file.name.toLowerCase();
        if (!(fileName.endsWith(".xls") || fileName.endsWith(".xlsx") || fileName.endsWith(".csv"))) {
            setFileErrorMessage(translate('OnlyXlsXlsxOrCscFilesAreAllowed'));
            setFile([]);
            setSelectedFile("");
            setFileChanged(false);
            return;
        }
        if (file.size === 0) {
            setFileErrorMessage(translate('pleaseSelectAValidFileTheFileSizeIsZeroBytes'));
            setFile([]);
            setSelectedFile("");
            setFileChanged(false);
            return;
        }
        dispatch(resetImportDataDetails());
        setAmountColumnError("");
        setFileErrorMessage("");
        const isValid = validateBeforeUpload();
        if (!isValid) return;

        setFile(file);
        setSelectedFile(file.name);
        setFileChanged(true);
    };

    useEffect(() => {
        const processFile = async () => {
            if (file && fileChanged) {
                setSelectedFile(file.name);
                setAmountColumnError("");
                setTransformedImport([]);
                const reader = new FileReader();

                reader.onload = async (e) => {
                    if (!e.target?.result) return;

                    const data = new Uint8Array(e.target.result as ArrayBuffer);
                    const workbook = XLSX.read(data, { type: "array" });

                    if (workbook.SheetNames.length > 1) {
                        setSheets(workbook.SheetNames);
                        setAmountColumn("");
                        setDescriptionColumn([]);
                    } else {
                        setSheets([]);
                        setSelectSheet("");
                        const excelData = await readExcel(workbook, 0);

                        if (excelData) {
                            await getParticipantFileMappingByParticipantIdInfo(
                                excelData.dropdownItems,
                                excelData.extractedKeys
                            );
                        }

                        setFileChanged(false);
                    }
                };

                reader.readAsArrayBuffer(file);
            }
        };

        processFile();
    }, [file && fileChanged]);

    const handleSheetChange = (sheetIndex: number, sheetName: string | null) => {
        const reader = new FileReader();
        reader.onload = async (e) => {
            if (!e.target?.result) return;
            const data = new Uint8Array(e.target.result as ArrayBuffer);
            const workbook = XLSX.read(data, { type: "array" });
            const excelData = await readExcel(workbook, sheetIndex);

            if (excelData) {
                await getParticipantFileMappingByParticipantIdInfo(
                    excelData.dropdownItems,
                    excelData.extractedKeys
                );
            }

            setFileChanged(false);
        };
        reader.readAsArrayBuffer(file);
    };
    const readExcel = async (wb: XLSX.WorkBook, sheetNumber: number) => {
        setIsLoading(true);
        setLoadingFlag(true);

        const wsName: string = wb.SheetNames[sheetNumber];
        const ws: XLSX.WorkSheet = wb.Sheets[wsName]; 

        if (!ws || !ws["!ref"]) {
            setIsLoading(false);
            setLoadingFlag(false);
            if (wb.SheetNames.length > 1) {
                notifyUser("Selected file sheet has no data", "error", "Budget Import");
            } else {
                notifyUser("Selected file has no data", "error", "Budget Import");
            }
            return null;
        }

        const range = XLSX.utils.decode_range(ws["!ref"]);

        if (range.e.r <= range.s.r) {
            setIsLoading(false);
            setLoadingFlag(false);
            notifyUser("File does not contain valid data rows", "error", "Budget Import");
            return null;
        }

        const extractedData: any[] = [];
        const dropdownItems: { id: number; name: string }[] = [];
        const extractedKeys: string[] = [];

        for (let rowIndex = range.s.r; rowIndex <= range.e.r; rowIndex++) {
            let rowData: Record<string, any> = {};
            for (let colIndex = range.s.c; colIndex <= range.e.c; colIndex++) {
                const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
                const cell = ws[cellAddress];
                const columnKey = `Column ${columnName[colIndex]}`;
                if (cell && cell.f) {
                    const regex = /^[0-9]/;
                    rowData[columnKey] = regex.test(cell.f) ? cell.f : "";
                } else if (cell?.v !== undefined && cell?.v !== null && cell?.v !== "") {
                    rowData[columnKey] = cell.v;
                } else {
                    rowData[columnKey] = "";
                }
                if (rowIndex === 0) {
                    dropdownItems.push({ id: colIndex + 1, name: columnKey });
                    extractedKeys.push(columnKey);
                }
            }
            extractedData.push(rowData);
        }
        const hasData = extractedData.slice(1).some(row =>
            Object.values(row).some(val => val !== "")
        );

        if (!hasData) {
            setIsLoading(false);
            setLoadingFlag(false);
            notifyUser("File contains only empty rows", "error", "Budget Import");
            return null;
        }

        setRowData(extractedData);
        setDescriptionColumnList(dropdownItems);
        setAmountColumnList(extractedKeys);
        setIsLoading(false);
        setLoadingFlag(false);
        return {
            dropdownItems,
            extractedKeys
        };
    };
    async function getParticipantFileMappingByParticipantIdInfo(
        descriptionColumnListParam: { id: number; name: string }[],
        amountColumnListParam: string[]
    ) {
        setLoadingFlag(true);
        try {
            const formate = "s";

            const responseList = await getParticipantFileMappingByParticipantIdType(
                participantId,
                constants.TYPE_BUDGET,
                formate,
                userDetails.clientId
            );

            if (
                responseList?.status === constants.STATUS_CODES.SUCCESS &&
                responseList?.data?.data?.participantsFileColumnMappingsVOList?.length > 0) {
                const mappingVO = responseList.data.data.participantsFileColumnMappingsVOList[0];
                setFileColumnMappingId(mappingVO?.id);
                setVersion(mappingVO?.version);
                dispatch(
                    setImportDataDetails({
                        ...importData,
                        fileColumnMappingDetailes: mappingVO,
                    })
                );
                const columns = mappingVO.descriptionColumns
                    .split(",")
                    .map((name: string) => name.trim());

                const fetchedItems = descriptionColumnListParam.filter(item =>
                    columns.includes(item.name)
                );

                setDescriptionColumn(fetchedItems);

                const selectedMonth = amountColumnListParam.find(
                    a => a === mappingVO.amountColumn
                );

                setAmountColumn(selectedMonth || "");
            } else {
                setMappingDetailsFlag(true);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoadingFlag(false);
            await getMapList();
        }
    }
    async function getMapList() {
        setLoadingFlag(true);
        try {
            const responseList = await getForecastMappingDetailsByFinancialYearsAndParticipantId(participantId, userDetails.clientId);
            if (responseList?.status === constants.STATUS_CODES.SUCCESS) {
                setForecastMappingDetails(responseList.data.data.fiscalExternalAccountSystemVOList);
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        } finally {
            setLoadingFlag(false);
        }
    }

    const handleCancel = () => {
        setOpenPopUp(true);
    };
    const handlePopUpClose = () => {
        setOpenPopUp(false);
        setOpenMappingDetailsPopUp(false);
        dispatch(setImportDataDetails({ isInitialRender: false }));
    };
    function handleConfirm() {
        navigate("/budgetListing");
    }


    const getAmountAndPerMonth = (item: any): { amount: string; monthlyAmounts: string[] } => {
        const rawAmount = item[amountColumn] ? parseFloat(item[amountColumn]) : 0;
        if (!isFinite(rawAmount) || monthCount <= 0) {
            return { amount: formatCurrency(0), monthlyAmounts: Array(monthCount).fill(formatCurrencywithoutDoller(0)) };
        }

        const perMonth = +(rawAmount / monthCount).toFixed(2);
        const totalAssigned = +(perMonth * monthCount).toFixed(2);
        const remainder = +(rawAmount - totalAssigned).toFixed(2);

        const monthlyAmounts = Array(monthCount).fill(perMonth);
        if (remainder !== 0) {
            monthlyAmounts[monthCount - 1] += remainder;
        }

        return {
            amount: formatCurrency(rawAmount),
            monthlyAmounts: monthlyAmounts.map(a => formatCurrencywithoutDoller(a))
        };
    };

    useEffect(() => {
        if (!rowData || rowData.length === 0) return;
        if (!descriptionColumn || descriptionColumn.length === 0) return;
        if (!amountColumn || amountColumn.trim() === "") return;

        const transformed = rowData.map((item: any, index: number) => {
            if (index === 0) return null;

            const rawAmount = item?.[amountColumn];
            const parsedAmount = parseFloat((rawAmount ?? "").toString().replace(/[^0-9.-]/g, ""));
            const isAmountValid = !isNaN(parsedAmount);

            const sortedDescriptionColumns = descriptionColumnList.filter(option =>
                descriptionColumn.some(selected => selected.name === option.name)
            );

            const locationGL = sortedDescriptionColumns
                ?.map(col => item?.[col.name]?.toString()?.trim() || "")
                .filter(val => val && val !== "Description")
                .join(" ")
                .replace(/\s+/g, " ")
                .trim();

            if (!locationGL || !isAmountValid) {
                return null;
            }

            const { amount, monthlyAmounts } = getAmountAndPerMonth(item);
            let dioceseGLMapping = null;

            const normalize = (str: string) =>
                str?.toString().replace(/\s+/g, " ").trim();

            const forecastMatch = forecastMappingDetails?.find((mapping: any) => {
                const matchedChart = standardChartList?.find((chart: any) =>
                    chart.subChartAccountNumber === mapping.accountNumber &&
                    normalize(mapping.description) === normalize(locationGL)
                );
                if (matchedChart) {
                    dioceseGLMapping = matchedChart;
                    return true;
                }
                return false;
            });

            const monthlyAmountsMap = monthOrder.reduce((acc: Record<string, string>, month, i) => {
                acc[month] = monthlyAmounts[i] ?? formatCurrencywithoutDoller(0);
                return acc;
            }, {});

            return {
                locationGL,
                amount,
                dioceseGLMapping,
                ...monthlyAmountsMap,
            };
        }).filter(Boolean);

        if (importData?.isInitialRender) {
            setTimeout(() => {
                setTransformedImport(importData?.transformedImport);
                dispatch(setImportDataDetails({ isInitialRender: false }));
            }, 4000);
        } else {
            setTransformedImport(transformed);
        }
    }, [importData?.isInitialRender, rowData, descriptionColumn, amountColumn, monthCount, forecastMappingDetails, standardChartList]);


    useEffect(() => {
        if (!mappingDetailsFlag) {

            const updated = transformedImport.map((row, index) => {
                const item = rowData[index];
                if (!item) return null;

                const rawAmount = item?.[amountColumn];
                const parsedAmount = parseFloat((rawAmount ?? "").toString().replace(/[^0-9.-]/g, ""));
                const isAmountValid = !isNaN(parsedAmount);

                const sortedDescriptionColumns = descriptionColumnList.filter(option =>
                    descriptionColumn.some(selected => selected.name === option.name)
                );

                const locationGL = sortedDescriptionColumns
                    ?.map(col => item?.[col.name]?.toString()?.trim() || "")
                    .filter(val => val && val !== "Description")
                    .join(" ")
                    .replace(/\s+/g, " ")
                    .trim();

                if (!locationGL || !isAmountValid) {
                    return null;
                }

                const updatedRow = {
                    ...row,
                    locationGL,
                    dioceseGLMapping: row?.dioceseGLMapping ?? null,
                };

                if (amountColumn) {
                    const { amount, monthlyAmounts } = getAmountAndPerMonth(item);
                    updatedRow.amount = amount;

                    monthOrder.forEach((month, i) => {
                        updatedRow[month] = monthlyAmounts[i] ?? formatCurrencywithoutDoller(0);
                    });
                }

                return updatedRow;
            }).filter(Boolean);

            setTransformedImport(updated);
        }
    }, [descriptionColumn, amountColumn]);




    useEffect(() => {
        if (participantId && year) {
            getForecastMappingDetailsByFinancialYearAndParticipantIdInfo();
        }
    }, [participantId, year]);
    async function getForecastMappingDetailsByFinancialYearAndParticipantIdInfo() {
        setLoadingFlag(true);
        try {
            const responseList = await getForecastMappingDetailsByFinancialYearAndParticipantId(year, participantId, constants.TYPE_BUDGET, userDetails.clientId);
            if (responseList?.status === constants.STATUS_CODES.SUCCESS) {
                setStandardChartList(responseList?.data?.data?.importChartAccountsMappingVOList[0]?.standardChartAccountsVOList);
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        } finally {
            setLoadingFlag(false);
        }
    }
    useEffect(() => {
        if (participantId) {
            getBudgetForecastEligibleYearInfo();
        }
    }, [participantId]);

    async function getBudgetForecastEligibleYearInfo() {
        setLoadingFlag(true);
        try {
            const responseList = await getBudgetForecastEligibleYearByParticipantId(participantId, userDetails.clientId);
            if (responseList?.status === constants.STATUS_CODES.SUCCESS) {
                SetBudgetYearsList(responseList?.data?.data?.yearsList);
                if (responseList?.data?.data?.yearsList && responseList?.data?.data?.yearsList.length > 0) {
                    setYear(responseList?.data?.data?.yearsList[0]);
                } else {
                    setBudgetLockedMessageFlag(true);
                }
            }

        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        } finally {
            setLoadingFlag(false);
        }
    }

    return (
        <StyledParentContainer>
            <StyledOneChildContainer>
                <StyledTwoChildContainer sx={{ border: "none" }}>
                    <SectionTitle>{translate('budgetImport')} </SectionTitle>
                    {budgetYearsList && budgetYearsList.length > 0 ? <Grid container spacing={2} sx={{ m: 2 }} direction={'column'} >
                        <Grid size={{ xs: 12, sm: 6, lg: 4 }} >
                            <CustomAutocomplete
                                labelText={translate('budgetYear')}
                                required
                                size='small'
                                id="budget-year"
                                options={budgetYearsList ?? []}
                                value={year}
                                onChange={(event, newValue) => {
                                    setYear(newValue || "");
                                    setIsDisabled(year === "" || !newValue);
                                    setSelectSheet("");
                                    handleSheetChange(0, "");
                                    setDescriptionColumn([]);
                                    setTransformedImport([]);
                                    setRowData([]);
                                    setAmountColumn("");
                                    setSelectedFile("");
                                }}
                                getOptionLabel={(option) => option}
                                placeholder={translate('budgetYear')}
                                error={yearError}
                            />
                            {yearError && (
                                <FormHelperText error>{translate('pleaseSelectaValidYear')} </FormHelperText>
                            )}
                        </Grid>
                        <Grid size={{ xs: 12, sm: 9, lg: 12 }}>
                            <StyledInputLabel sx={{ fontSize: 18 }}>{translate('selectFile')} </StyledInputLabel>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, lg: 4 }}  >
                            <FileUpload onFilesSelected={handleFilesSelected} />
                        </Grid>

                        <Grid size={{ xs: 12, sm: 9, lg: 12 }}>
                            {selectedFile && <StyledInputLabel sx={{ whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word' }}> {translate('selectedFile')}: {selectedFile}</StyledInputLabel>}
                            {fileErrorMessage && (
                                <FormHelperText error>{fileErrorMessage}</FormHelperText>
                            )}
                        </Grid>
                        <Grid size={{ xs: 12, sm: 9, lg: 8 }}>
                            <SubSectionTitle  >{translate('columnMappingDetails')}</SubSectionTitle>
                        </Grid>

                        {selectedFile && sheets && sheets.length > 1 &&
                            <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                                <CustomAutocomplete
                                    labelText={translate('selectSheet')}
                                    required
                                    size='small'
                                    options={sheets}
                                    value={selectSheet}
                                    onChange={(event, newValue) => {
                                        setSelectSheet(newValue ?? "");
                                        const idx = sheets.indexOf(newValue);
                                        handleSheetChange(idx !== -1 ? idx : 0, newValue ?? "");
                                        setDescriptionColumn([]);
                                        setTransformedImport([]);
                                        setRowData([]);
                                        setAmountColumn("");
                                    }}
                                    getOptionLabel={(option) => option}
                                    placeholder="Select a Sheet"
                                />
                            </Grid>}
                        {selectedFile && <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                            <CustomAutocomplete
                                labelText={translate('selectDescriptionColumn')}
                                size="small"
                                multiple
                                options={mergedOptions}
                                value={
                                    descriptionColumn.length === descriptionColumnList.length
                                        ? [SELECT_ALL_OPTION, ...descriptionColumnList]
                                        : descriptionColumnList.filter(option =>
                                            descriptionColumn.some(selected => selected.name === option.name)
                                        )
                                }
                                onChange={(event, newValue) => {
                                    const isSelectAllInNewValue = newValue.some((item: any) => item.id === SELECT_ALL_OPTION.id);
                                    const selectedWithoutAll = newValue.filter((item: any) => item.id !== SELECT_ALL_OPTION.id);
                                    if (isSelectAllInNewValue && descriptionColumn.length !== descriptionColumnList.length) {
                                        setDescriptionColumn([...descriptionColumnList]);
                                        validateAmountNotInDescription(descriptionColumnList, amountColumn);
                                        return;
                                    }
                                    if (descriptionColumn.length === descriptionColumnList.length && !isSelectAllInNewValue) {
                                        setDescriptionColumn(selectedWithoutAll);
                                        validateAmountNotInDescription(selectedWithoutAll, amountColumn);
                                        return;
                                    }
                                    if (
                                        descriptionColumn.length === descriptionColumnList.length &&
                                        selectedWithoutAll.length === descriptionColumnList.length - 1
                                    ) {
                                        setDescriptionColumn(selectedWithoutAll);
                                        validateAmountNotInDescription(selectedWithoutAll, amountColumn);
                                        return;
                                    }
                                    if (selectedWithoutAll.length === descriptionColumnList.length) {
                                        setDescriptionColumn([...descriptionColumnList]);
                                        validateAmountNotInDescription(descriptionColumnList, amountColumn);
                                        return;
                                    }
                                    setDescriptionColumn(selectedWithoutAll);
                                    validateAmountNotInDescription(selectedWithoutAll, amountColumn);
                                }}
                                getOptionLabel={(option) => option.name}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                placeholder={descriptionColumn.length === 0 ? translate('selectDescriptionColumn') : ''}
                                renderOption={(props, option, { selected }) => {
                                    const isAllSelected = descriptionColumn.length === descriptionColumnList.length;
                                    const isCurrentSelectAll = option.id === SELECT_ALL_OPTION.id;

                                    return (
                                        <li {...props}>
                                            <Checkbox
                                                checked={isCurrentSelectAll ? isAllSelected : selected}
                                                indeterminate={isCurrentSelectAll && descriptionColumn.length > 0 && !isAllSelected}
                                                tabIndex={-1}
                                                disableRipple
                                            />
                                            <ListItemText primary={option.name} />
                                        </li>
                                    );
                                }}
                            />
                        </Grid>}

                        {selectedFile && yearlyType?.value !== "monthly_values" && <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                            <CustomAutocomplete
                                labelText={translate('selectAmountColumn')}
                                size='small'
                                options={amountColumnList}
                                value={amountColumn}
                                onChange={(event, newValue) => {
                                    onchangeAmount(newValue ?? "");
                                    validateAmountNotInDescription(descriptionColumn, newValue ?? "");
                                }}
                                getOptionLabel={(option) => option}
                                placeholder={translate('selectAmountColumn')}
                                error={!!amountColumnError}
                                helperText={amountColumnError}
                            />
                        </Grid>}
                        {selectedFile && period?.value === constants.PERIOD_YEARLY && yearlyType?.value === "monthly_values" &&
                            (<Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                                <StyledInputLabel sx={{ marginTop: 2 }} shrink>Monthly Select Column</StyledInputLabel>
                                {monthOrderOptions.map((month) => (
                                    <Box key={month.id} sx={{ mb: 2 }}>
                                        <CustomAutocomplete
                                            labelText={month.name}
                                            options={["Select", ...amountColumnList]}
                                            value={amounts[month.id] || constants.SELECT_PLACEHOLDER}
                                            onChange={(event, newValue) => handleAmountChange(month.id, newValue === constants.SELECT_PLACEHOLDER ? "" : newValue ?? "")}
                                            getOptionLabel={(option: string) => option}
                                            placeholder="Select"
                                            error={!!amountColumnError}
                                        />
                                    </Box>
                                ))}
                            </Grid>
                            )}
                    </Grid> : budgetLockedMessageFlag && <Grid container spacing={2} sx={{ m: 2 }} direction={'column'} >
                        <Typography sx={{ paddingLeft: '1%' }}>{translate('budgetLockedMessage')}</Typography> </Grid>}
                    {selectedFile && rowData && !loadingFlag && (
                        <TableContainer sx={{ overflow: 'auto' }}>
                            <StyledTable
                                stickyHeader
                                aria-label="sticky table"
                                size="small"
                                sx={{
                                    [`& .${tableCellClasses.root}`]: {
                                        borderBottom: 'none',
                                        borderTop: 'none',
                                    },
                                }}
                            >
                                <TableHead>
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableCell key={column.id} align={column.align} className="cellTask">
                                                {column.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {isLoading ? (
                                        <TableRow>
                                            <TableCell align="center" colSpan={columns.length}>
                                                <div className="loading-container">
                                                    <CircularProgress />
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        transformedImport.map((row, index) => {
                                            if (!row.locationGL || row.locationGL.trim() === "") {
                                                return null;
                                            }
                                            return (
                                                <React.Fragment key={index}>
                                                    <TableRow sx={{ backgroundColor: index % 2 === 0 ? "#f1f3f4" : "#fff" }}  >
                                                        {columns.map((column) => {
                                                            return (
                                                                <TableCell key={column.id} align={column.align} className="left-aligned-text">
                                                                    {column.id === "dioceseGLMapping" ? (
                                                                        <Autocomplete
                                                                            sx={{ width: { xs: "100%", sm: 250 } }}
                                                                            options={[defaultSelectOption, ...(standardChartList || [])]}
                                                                            value={row.dioceseGLMapping ?? defaultSelectOption}
                                                                            onChange={(event, newValue) => handleDioceseGLMappingChange(index, newValue)}
                                                                            getOptionLabel={(option) => option?.displayName ?? ""}
                                                                            isOptionEqualToValue={(option, value) =>
                                                                                option?.forecastSubChartId === value?.forecastSubChartId
                                                                            }
                                                                            renderInput={(params) => (
                                                                                <TextField
                                                                                    {...params}
                                                                                    placeholder={translate('glMapping')}
                                                                                    size="small"
                                                                                    InputProps={{
                                                                                        ...params.InputProps,
                                                                                        style: {
                                                                                            color: (row.dioceseGLMapping?.forecastSubChartId == null) ? 'red' : 'inherit',
                                                                                        },
                                                                                    }}
                                                                                />
                                                                            )}
                                                                            renderOption={(props, option) => (
                                                                                <Box
                                                                                    component="li"
                                                                                    {...props}
                                                                                    sx={{
                                                                                        whiteSpace: 'normal',
                                                                                        wordBreak: 'break-word',
                                                                                        maxWidth: '500px',
                                                                                    }}
                                                                                    title={option.displayName}
                                                                                >
                                                                                    {option.displayName}
                                                                                </Box>
                                                                            )}
                                                                            PopperComponent={CustomPopper}
                                                                            slotProps={{
                                                                                popper: {
                                                                                    modifiers: [
                                                                                        { name: 'preventOverflow', options: { altAxis: true, tether: false, boundary: 'viewport' } },
                                                                                        { name: 'flip', options: { fallbackPlacements: ['left-start', 'left'] } },
                                                                                        { name: 'offset', options: { offset: [0, 8] } },
                                                                                    ],
                                                                                },
                                                                            }}
                                                                        />
                                                                    ) : column.id === "locationGL" ? (
                                                                        row.locationGL ?? "-"
                                                                    ) : column.id === "amount" ? (
                                                                        row.amount ?? "0.00"
                                                                    ) : (CommonUtilities.monthRegularList.includes(column.id) ? (
                                                                        <Box position="relative" display="inline-block">
                                                                            <Box position="absolute" top={10} bgcolor="white" zIndex={1}>
                                                                                {" $ "}
                                                                            </Box>
                                                                            <Tooltip title={row[column.id as keyof typeof row] ?? ""} arrow placement="top">
                                                                                <Box display="inline-block" width="100%">
                                                                                    <CustomTextField
                                                                                        value={row[column.id as keyof typeof row] ?? ""}
                                                                                        onChange={(e) => handleForecastChange(column.id, e.target.value, index)}
                                                                                        onBlur={(e) => handleForecastBlur(column.id, e.target.value, index)}
                                                                                        inputProps={{
                                                                                            maxLength: 13,
                                                                                            style: { textAlign: "right", paddingLeft: 0, marginRight: 0.1 },
                                                                                        }}
                                                                                        sx={{ marginLeft: 0.5, pl: 0 }}
                                                                                    />
                                                                                </Box>
                                                                            </Tooltip>
                                                                        </Box>
                                                                    ) : (
                                                                        column.id
                                                                    ))}
                                                                </TableCell>
                                                            );
                                                        })}
                                                    </TableRow>

                                                </React.Fragment>
                                            );
                                        })
                                    )}

                                </TableBody>
                            </StyledTable>
                        </TableContainer>
                    )}

                    <Box className={basestyle.buttoncontainer} sx={{ mt: 3 }}>
                        <ContainedButton onClick={handleContinue} disabled={transformedImport.length === 0} >  {translate('continue')}   </ContainedButton>
                        <OutlinedButton onClick={handleCancel}>  {translate('cancel')}  </OutlinedButton>
                    </Box>
                    <CancelPopUp
                        open={openPopUp}
                        handleClose={handlePopUpClose}
                        saveChanges={() => handleConfirm()}
                        popupTitle={translate('confirmCancel')}
                        message={translate('doYouWantToCancelChanges?')}
                    />
                    <MappingDetailsWarningPopUp
                        open={openMappingDetailsPopUp}
                        handleClose={handlePopUpClose}
                        saveChanges={() => handleMappingDetailsConfirm()}
                        popupTitle={translate('mappingDetailsWarning')}
                        message={translate('doYouWantToMapTheSameMappingToOtherDescription?')}
                    />
                    <Backdrop
                        sx={{
                            color: "#fff",
                            zIndex: (theme) => theme.zIndex.drawer + 1,
                            display: "flex",
                            flexDirection: "column",
                        }}
                        open={loadingFlag}
                    >
                        <CircularProgress color="inherit" />
                        <SubSectionTitle  >{translate('pleasewait')}</SubSectionTitle>
                    </Backdrop>
                </StyledTwoChildContainer>
            </StyledOneChildContainer>
        </StyledParentContainer>

    );
};
export default BudgetImport;